export class LocalStorageItem {
  constructor(public key: string, public value: string) {}
}

export class LocalStorageWorker {
  private _isLocalStorageSupported: boolean;

  /**
   * True if the browser supports localStorage, false otherwise.
   */
  public get isLocalStorageSupported(): boolean {
    return this._isLocalStorageSupported;
  }

  constructor() {
    this._isLocalStorageSupported = typeof window["localStorage"] != "undefined" && window["localStorage"] != null;
    if (!this._isLocalStorageSupported) {
      console.warn("Local Storage not supported by browser.");
    }
  }

  /**
   * Adds a value to localStorage
   */
  add(key: string, item: string) {
    if (this.isLocalStorageSupported) {
      localStorage.setItem(key, item);
    }
  }

  /**
   * Gets all items from localStorage
   */
  getAllItems(): Array<LocalStorageItem> {
    var list = new Array<LocalStorageItem>();

    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      var value = localStorage.getItem(key);

      list.push(new LocalStorageItem(key, value));
    }

    return list;
  }

  /**
   * Gets all keys from localStorage
   */
  getAllKeys(): Array<string> {
    var list = new Array<string>();

    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      list.push(key);
    }

    return list;
  }

  /**
   * Gets all values from localStorage
   */
  getAllValues(): Array<string> {
    var list = new Array<string>();

    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      var value = localStorage.getItem(key);

      list.push(value);
    }

    return list;
  }

  /**
   * Get a particular item by key from localStorage
   */
  get(key: string): string {
    if (this._isLocalStorageSupported) {
      var item = localStorage.getItem(key);
      return item;
    } else {
      return null;
    }
  }

  /**
   * Removes the item with the given key from localStorage
   */
  remove(key: string) {
    if (this._isLocalStorageSupported) {
      localStorage.removeItem(key);
    }
  }

  /**
   * Clears the localStorage and removes all items from it
   */
  clear() {
    if (this._isLocalStorageSupported) {
      localStorage.clear();
    }
  }
}
